<div class="lock">
  <img
    [src]="'assets/images/hexa-bill-time.png' | flagUrl"
    alt="" />
  <div class="lock__content">
    <h1>Akun Terkunci</h1>
    <p>Segera Lunasi Tagihan, yang sudah melewati jatuh tempo untuk melanjutkan operasional anda</p>
    @if (profile?.abilities?.includes(PermissionType.CASH_INVOICING_VIEW)) {
      <ion-button (click)="toPaymentCashPage()">Lihat Tagihan</ion-button>
    }
  </div>
</div>
